module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACHSURBVHgB7dDBCYAwDEDRjOAIjtANHcEROoIj1E0cwRFqChFqITSBmFM+5NQ2DwoQRVHkXa11awOeEfrmgw+oD86g/+K4OA/QRdO3g2UMutKMeAaLOLQ7t8dnqDmOjxYpOsGPtguk4eWiQSf4CdLwcsK5NSiDtx0JNBFeVF/1xYsajaIokvQA1ISSZWVn0xIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/up.png
// module id = U+NF
// module chunks = 34